'use strict';

export default class ActiveController {

  /*@ngInject*/
  constructor($http, $stateParams) {
    this.$http = $http;
    this.$stateParams = $stateParams;

    this.limit = 50;
    this.page = 1;
  }

  $onInit() {
    this.page = this.$stateParams.page || 1;
    this.getData();
  }

  getData() {
    let params = {
      page: this.page,
      limit: this.limit
    };
    this.$http.get('/api/myScriptActives', {params: params}).then(res => {
      console.log('===============')
      this.data = res.data;
    });
  }

  pageChanged() {
    this.getData();
  }
  

}



// WEBPACK FOOTER //
// ./client/app/myscripts/active/active.controller.js